import * as React from 'react';
const SCROLL_LOAD_THRESHOLD = 200; // px from the bottom that triggers the next page
/**
 * Infinite scroll for a scrolling list or grid (media picker, object search). Attach `ref` and
 * `onScroll` to the scrolling element.
 */
export default function useInfiniteScroll(options) {
    const { loading, hasMore, count, resetKey, onLoadMore } = options;
    const ref = React.useRef(null);
    // The count the top-up has already asked past, so a page that comes back
    // empty (or short) can't be requested over and over.
    const toppedUpAt = React.useRef(-1);
    React.useEffect(() => { toppedUpAt.current = -1; }, [resetKey]);
    // A page short enough to leave the grid unscrollable would strand the user
    // on it — there is no scrollbar left to fire the scroll handler.
    React.useEffect(() => {
        if (loading || !hasMore || !count)
            return;
        if (toppedUpAt.current === count)
            return;
        const el = ref.current;
        if (!el || el.scrollHeight > el.clientHeight)
            return;
        toppedUpAt.current = count;
        onLoadMore();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, hasMore, count, resetKey]);
    function onScroll(e) {
        if (loading || !hasMore)
            return;
        const el = e.currentTarget;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_LOAD_THRESHOLD) {
            onLoadMore();
        }
    }
    return { ref, onScroll };
}
